const s = {
  "weight-loss-graph": "_weight-loss-graph_jd2nl_1"
};
export {
  s as default
};
